<template>
  <div class="l-container--width-80">
    <h1
      :class="{
        'c-text--mobile-h1': $vuetify.display.mobile,
        'text-left': $vuetify.display.mobile,
      }"
    >
      Citation Policy
    </h1>
    <h2
      class="text-left mk-spacing--top-7"
      :class="{'c-text--mobile-h2': $vuetify.display.mobile}"
    >
      Introduction
    </h2>
    <p class="m-spacing--top-5 mk-text--regular text-left">
      <ul class="ml-4">
        <li>
          ATT&CK Evaluations are not competitive analyses — they show what the evaluation observed and do not
          provide a “winner”. We do not rank or rate research participants that take part in our evaluations.
        </li>
        <li>MITRE reserves the right to change these guidelines at any time without notice.</li>
        <li>Only approved materials may be published.</li>
      </ul>
    </p>
    <h2
      class="text-left m-spacing--top-7"
      :class="{'c-text--mobile-h2': $vuetify.display.mobile}"
    >
      Uses That Require MITRE Approval
    </h2>
    <p class="m-spacing--top-5 mk-text--regular text-left">
      <ul class="ml-4">
        <li>All commercial use of MITRE research in any form.</li>
      </ul>
    </p>
    <h2
      class="text-left m-spacing--top-7"
      :class="{'c-text--mobile-h2': $vuetify.display.mobile}"
    >
      Uses That Do Not Require MITRE Approval
    </h2>
    <p class="m-spacing--top-5 mk-text--regular text-left">
      <ul class="ml-4">
        <li>
          Members of the press and journalists are permitted to utilize excerpts from our research without our
          approval. To collaborate on media engagements please send requests to
          <a href="mailto:evals-marketing@mitre.org?subject=ATT&CK Evaluations Media Engagement Request">evals-marketing@mitre.org</a>
        </li>
      </ul>
    </p>
    <h2
      class="text-left m-spacing--top-7"
      :class="{'c-text--mobile-h2': $vuetify.display.mobile}"
    >
      Dos and Don'ts
    </h2>
    <h3
      class="text-left m-spacing--top-5"
      :class="{'c-text--mobile-h3': $vuetify.display.mobile}"
    >
      Do
    </h3>
    <p class="m-spacing--top-5 mk-text--regular text-left">
      <ul class="ml-4">
        <li>
          Attribute the research to MITRE: provide a link to
          <a href="https://evals.mitre.org/">ATT&CK Evaluations website</a>
          or the specific round results. Reference to the results is required.
        </li>
        <li>
          Make it clear that any assessment of performance is your own (not MITRE's) and that we do not rank
          or rate participants.
        </li>
        <li>
          We issue a unique digital badge for the round prior to publication. Evaluation partners may use this badge
          as a stand-alone graphic or with approved marketing collateral.
        </li>
      </ul>
    </p>
    <h3
      class="text-left m-spacing--top-5"
      :class="{'c-text--mobile-h3': $vuetify.display.mobile}"
    >
      Do Not
    </h3>
    <p class="m-spacing--top-5 mk-text--regular text-left">
      <ul class="ml-4">
        <li>
          Research Partners may not make any statement that implies or suggests MITRE ranked Evaluation
          Partners in any kind of order.
        </li>
        <li>Do not reference or use metrics not assessed by MITRE.</li>
        <li>
          Do not use terms like "won", "scored", "ranked", or "dominated" as those are inaccurate ways to describe
          evaluation results, which are not a competitive analysis
        </li>
        <li>
          Do not make claims about other Evaluation partners' results or imply or suggest that they lost,
          underperformed, or scored lower in any kind of rating, ranking, ordering, or comparison.
        </li>
        <li>
          Do not re-publish, quote, or cite ATT&CK Evaluations related content without prior approval from MITRE.
          This also applies to any sourced quotes or graphics your firm may supply to third-parties such as
          agencies, press, bloggers, or media. Do not re-publish, quote, or cite ATT&CK Evaluations related content
          from other Evaluations participants or media outlets that has not been approved by MITRE.
        </li>
        <li>
          Do not publish any reference to ATT&CK Evlautions that has not been previously reviewed and approved by
          MITRE.
        </li>
      </ul>
    </p>
    <h2
      class="text-left m-spacing--top-7"
      :class="{'c-text--mobile-h2': $vuetify.display.mobile}"
    >
      Approval Process
    </h2>
    <p class="m-spacing--top-5 mk-text--regular text-left">
      <ul class="ml-4">
        <li>
          Submit all materials to
          <a href="mailto:evals-marketing@mitre.org?subject=ATT&CK Evaluations Approval Request">evals-marketing@mitre.org</a>
        </li>
        <li>Please ensure the following:</li>
        <ul class="ml-4">
          <li>Materials are shared in their full context in an editable format.</li>
          <li>Please share any special considerations (timelines) you may have and we will do our best to accomodate.</li>
        </ul>
        <li>Please allow at least 3 business days to process requests.</li>
        <li>
          Approval is limited to the materials and context of the request and does not extend to other uses of the
          materials.
        </li>
      </ul>
    </p>
    <h2
      class="text-left m-spacing--top-7"
      :class="{'c-text--mobile-h2': $vuetify.display.mobile}"
    >
      Violations
    </h2>
    <p class="m-spacing--top-5 mk-text--regular text-left">
      <ul class="ml-4">
        <li>
          Violation of these guidelines can and will result in immediate suspension from the Evaluations publication
          and may preclude participation in future research projects. MITRE reserves the right to withhold
          reinstatement of results after a violation.
        </li>
        <li>
          If you are aware of any materials that violate our policies or misrepresent our research, please contact
          <a href="mailto:evals-marketing@mitre.org?subject=ATT&CK Evaluations Citation Violation">evals-marketing@mitre.org</a>
        </li>
      </ul>
    </p>
    <p class="m-spacing--top-7 mk-text--regular text-left">
      <i>Updated 2025-01-30</i>
    </p>
  </div>
</template>
